import BoardTemplateManagerStep from './BoardTemplateManagerStep';

export default BoardTemplateManagerStep;
